import gql from 'graphql-tag';
import FieldsBooking from 'graphql/fields/FieldsBooking'

export default gql(`
	query qrcode( $guid: String! ){
		qrcode( guid: $guid ) {
			guid
			data
			
			booking {
				${FieldsBooking}
			}
		}
	}
`);

